import { formatNumber } from 'lib/utils/number';
import validate from 'lib/utils/validationRules';

export function formatAmount(amount, currency) {
  if (validate.isNotNumber(amount) || validate.isNotObject(currency)) {
    return '';
  }

  const type = currency.type ? currency.type : 'DEFAULT';
  const significantZeros = currency.significant_zeros ? currency.significant_zeros : 2;
  const preparedValue = amount / 10 ** significantZeros;

  const formattedAmount = formatNumber(preparedValue, {
    decimals: significantZeros,
    decimalsSeparator: '.',
    thousandSeparator: ' ',
    trailingZeros: type === 'DEFAULT',
  });

  if (currency.sign) {
    return `${formattedAmount} ${currency.sign}`;
  }

  return formattedAmount;
}

export function normalizeAmount(amount, currency) {
  const replacedAmount = String(amount).replace(/\s/g, '');
  const preparedAmount = Math.round(replacedAmount * 10 ** (currency.significant_zeros || 2));

  return validate.isPositiveNumber(preparedAmount) ? preparedAmount : null;
}
